export default __webpack_public_path__ + "static/media/icon-external-report.8638a7ed.svg";